import { useState } from "react";
import { BarChart3, ChevronDown } from "lucide-react";
import { usePolls } from "@/api/hooks";
import { cn } from "@/lib/utils";
import { PollCard } from "./polls/PollCard";

/**
 * Polls created in the old channel "Polls" panel, before polls were posted as
 * messages. New polls come from the composer's Poll button and appear in the
 * conversation; this collapsed strip keeps the earlier ones reachable. Hidden
 * when the channel has none.
 */
export function PollsPanel({ channelId }: { channelId: string }) {
    const polls = usePolls(channelId);
    const [open, setOpen] = useState(false);
    const list = polls.data ?? [];
    if (list.length === 0) return null;
    return (
        <div className="mx-4 my-1.5 shrink-0">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
                className="flex items-center gap-1 rounded-md border bg-card px-2 py-1 text-xs text-muted-foreground hover:bg-muted"
            >
                <BarChart3 className="h-3.5 w-3.5" aria-hidden />
                Earlier polls ({list.length})
                <ChevronDown className={cn("h-3 w-3 transition-transform", open && "rotate-180")} aria-hidden />
            </button>
            {open ? (
                <div className="mt-2 max-h-80 space-y-2 overflow-y-auto">
                    {list.map((p) => <PollCard key={p.id} pollId={p.id} />)}
                </div>
            ) : null}
        </div>
    );
}
